import Loader from "react-loader-spinner";
import { faBug } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment, useEffect, useState, } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import DatePicker from "react-datepicker2";
import { useSelector, useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import BihamtaTable from "../../Components/BihamtaTable";
import { getProductBugDetailedReport, getProductBugReport } from "../store/api/Services";
import { EyeFill, EyeSlashFill, FileEarmarkExcelFill, Printer, PrinterFill, Search } from "react-bootstrap-icons";
import { exportToExcel } from "../../store/api/CommonFunctions";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import { getAllGuaranteeHolders } from "../store/api/GuaranteeApi";
import { getAllProductTypes } from "../store/api/GetAllProduct";
import { Bar, BarChart, CartesianGrid, Label, ResponsiveContainer, XAxis, YAxis } from "recharts";

const ProductBugReport = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [showFilter, setShowFilter] = useState(true);
    const { filterData, settings, dataList } = useSelector(state => { return { filterData: state.service.pBugDetailedReportFilters, settings: state.SystemSettingsReducer.systemSettings, dataList: state.service.productBugReport } });
    const { register, handleSubmit } = useForm();
    const [dateFilters, setDateFilters] = useState({});
    const [pending, setPending] = useState(false);
    const [holders, setProductHolders] = useState([]);
    const [productTypes, setProductTypes] = useState([]);
    const [groupOnProductType, setGroupOn] = useState(filterData?.GroupOnProductType ?? false);
    const settingNames = ['ProductGrouppingType'];
    const pgType = Array.isArray(settings) && settings.find(s => s.SettingName === "ProductGrouppingType") ?
        Number(settings.find(s => s.SettingName === "ProductGrouppingType").SettingValue) : 1;
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف", showInMobile: true },
        { colName: "ProductName", colTitle: (pgType === 1 ? "نام" : "نوع") + " محصول", showCondition: () => groupOnProductType },
        { colName: "BugCode", colTitle: "کد خرابی", showInMobile: true, showCondition: () => !groupOnProductType },
        { colName: "BugDesc", colTitle: "شرح خرابی", showInMobile: true, showCondition: () => !groupOnProductType },
        { colName: "Count", colTitle: "تعداد" },
        { colName: "BugAvgTotalTime", colTitle: "میانگین زمان تعمیر(TAT)", showCondition: () => groupOnProductType }
    ]
    function search(data) {
        const dateFrom = document.getElementsByName("DateFrom")[0].value;
        if (dateFrom !== "") {
            data.ContactDateFrom = dateFilters.DateFrom;
            data.PDateFrom = dateFrom;
        }
        const dateTo = document.getElementsByName("DateTo")[0].value;
        if (dateTo !== "") {
            data.ContactDateTo = dateFilters.DateTo;
            data.PDateTo = dateTo;
        }
        const arciveDateFrom = document.getElementsByName("ArchiveDateFrom")[0].value;
        if (arciveDateFrom !== "") {
            data.ArchiveDateFrom = dateFilters.ArchiveDateFrom;
            data.PArchiveDateFrom = arciveDateFrom;
        }
        const archiveDateTo = document.getElementsByName("ArchiveDateTo")[0].value;
        if (archiveDateTo !== "") {
            data.ArchiveDateTo = dateFilters.ArchiveDateTo;
            data.PArchiveDateTo = archiveDateTo;
        }        
        data.Skip = 0;
        data.GroupOnProductType = groupOnProductType;
        dispatch(getProductBugReport(data, groupOnProductType));

    }
    function toExcel() {
        const url = `api/ServiceReportsAPI/GetProductBugReport?groupByProductType=${groupOnProductType}`;
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        searchArgs.Skip = 0;
        setPending(true);
        exportToExcel("ProductBugReport", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function printReport(e) {
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        searchArgs.Skip = 0;
        history.push({
            pathname: `/PrintViewer/ProductBugReport/${e.ctrlKey}`,
            state: {
                dataUrl: `api/ServiceReportsAPI/GetProductBugReport?groupByProductType=${groupOnProductType}`,
                method: "post",
                fetchBody: JSON.stringify(searchArgs)
            }
        });
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function rowClick(row) {
        dispatch(getProductBugDetailedReport({ BugID: row.BugID, BugDesc: row.BugDesc, ProductType: row.ProductName, GroupOnProductType: groupOnProductType }));
        history.push("/Services/ProductBugDetailedReport");
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات";
        dispatch(getSystemSettings(settingNames));
        getAllGuaranteeHolders("", setProductHolders);
        getAllProductTypes(setProductTypes);
    }, [])
    return (
        <div className="container-fluid mt-1">
            <br />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faBug} size="lg" />&nbsp;گزارش ایرادات محصول به تفکیک نوع
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <form onSubmit={handleSubmit(search)}>
                        <Row id="divFilters" className="rowBorder">
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                            </div>
                            <Col md={2} className="form-group">
                                <label>تاریخ پذیرش از: </label>
                                <DatePicker className="form-control" timePicker={false} isGregorian={false} name="DateFrom" onChange={val => dateFilters.DateFrom = val.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ پذیرش تا: </label>
                                <DatePicker className="form-control" timePicker={false} isGregorian={false} name="DateTo" onChange={val => dateFilters.DateTo = val.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={1} className="form-group">
                                <label className="ellipsisLabel">تاریخ بایگانی از: </label>
                                <DatePicker className="form-control" timePicker={false} isGregorian={false} name="ArchiveDateFrom"
                                    onChange={val => dateFilters.ArchiveDateFrom = val.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={1} className="form-group">
                                <label className="ellipsisLabel">تاریخ بایگانی تا: </label>
                                <DatePicker className="form-control" timePicker={false} isGregorian={false} name="ArchiveDateTo"
                                    onChange={val => dateFilters.ArchiveDateTo = val.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>کد محصول: </label>
                                <Form.Control name="ProductCode" ref={register({})} />
                            </Col>
                            {
                                pgType === 1 ?

                                    <Col md={2} className="form-group">
                                        <label>نام محصول:</label>
                                        <Form.Control name="ProductName" ref={register({})} />
                                    </Col>
                                    :
                                    <Fragment>
                                        <Col md={2} className="form-group">
                                            <label>مارک محصول:</label>
                                            {holders === "PENDING" ?
                                                <div className="form-control" style={{ textAlign: "center" }}>
                                                    <Loader type="BallTriangle" width={22} height={22} color="#bb1370" />
                                                </div> :
                                                <select className="form-control" name="ProductHolder" ref={register({})} defaultValue={filterData?.ProductHolder ?? ""}>
                                                    <option value="">انتخاب کنید</option>
                                                    {Array.isArray(holders) && holders.map((item, i) => <option value={item.HolderName} key={i}>{item.HolderName}</option>)}
                                                </select>
                                            }
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>نوع محصول:</label>
                                            {productTypes === "PENDING" ?
                                                <div className="form-control" style={{ textAlign: "center" }}>
                                                    <Loader type="BallTriangle" width={22} height={22} color="#bb1370" />
                                                </div> :
                                                <select className="form-control" name="ProductType" ref={register({})} defaultValue={filterData?.ProductType ?? ""}>
                                                    <option value="">انتخاب کنید</option>
                                                    {Array.isArray(productTypes) && productTypes.map((item, i) => <option value={item.Name} key={i}>{item.Name}</option>)}
                                                </select>
                                            }
                                        </Col>
                                    </Fragment>
                            }
                            <Col md={2} className="form-group">
                                <label>مدل محصول: </label>
                                <Form.Control name="ProductModel" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group" style={{ display: "flex", alignItems: "flex-end" }}>
                                <div className="rowBorder" style={{ background: "transparent", padding: ".375rem .75rem", marginTop: "5px", lineHeight: "1.9", width: "100%" }}>
                                    <input type="checkbox" className="form-check-input" onChange={e => setGroupOn(e.target.checked)} defaultChecked={filterData?.GroupOnProductType ?? false} />&nbsp;نمایش به تفکیک نوع محصول
                                </div>
                            </Col>
                        </Row>
                        <Button type="submit" className="mt-1 group-Btn-large"><Search size={18} />&nbsp; جستجوی ایراد</Button>
                        <Button variant="secondary" className="mt-1 group-Btn-large" onClick={printReport}><Printer size={18} />&nbsp; چاپ گزارش</Button>
                    </form>
                    <Row>
                        <Col md={4}>
                            {!pending &&
                                <div style={{ padding: 1, width: "100%", textAlign: "left", marginTop: "5px" }}>
                                    <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                                </div>}
                            {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                            <BihamtaTable columns={tableCols} reducerName="service" objectName="productBugReport" maxHeight={500} className="mt-0 mb-0"
                                filterData={filterData} hasPaging style={{ whiteSpace: "nowrap" }} rowClick={rowClick} />
                        </Col>
                        <Col md={8}>
                            {dataList?.Data?.length > 0 &&
                                <ResponsiveContainer width="100%" height="100%" className="barChart" debounce={300}>
                                    <BarChart data={dataList.Data}>
                                        <XAxis dataKey={groupOnProductType ? "ProductName" : "BugDesc"} style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100} height={50} angle={-18} tickMargin={6}>
                                            <Label value={groupOnProductType ? "نوع محصول" : "عنوان ایراد"} offset={2} position="insideBottom" style={{ fill: "blue" }} />
                                        </XAxis>
                                        <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} tickMargin={5}
                                            label={{ value: "تعداد", angle: 90, style: { fill: "blue" } }} />
                                        <CartesianGrid />
                                        <Bar dataKey="Count" fill="#4b75bd" label={{ position: 'top' }} isAnimationActive={false} />
                                    </BarChart>
                                </ResponsiveContainer>
                            }

                        </Col></Row>
                </Card.Body>
            </Card>
        </div>
    )
}
export default ProductBugReport;